module.exports = __webpack_public_path__ + "static/media/image2.9e9cc69c.png";